import React from 'react';

const ErrorBoundaryTest: React.FC = () => {
  // This component will throw an error on render
  throw new Error('This is a test error for the error boundary');

  return null; // This line will never be reached
};

export default ErrorBoundaryTest;
